<template>
  <form
    name="SBAmazonPayConfirmCall"
    action="/draft_orders/confirm"
    method="post"
  >
    <noscript>
      <h2>処理を続けます。</h2>
      <p>ボタンをクリックしてください。</p>
      <input type="submit" value="OK" />
    </noscript>
    <div class="draft-order__pay-form__container">
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <input
        type="hidden"
        name="draft_order_form[draft_order_id]"
        :value="draftOrderForm.draft_order_id"
      />
      <input
        type="hidden"
        name="draft_order_form[gift_card_session_id]"
        :value="draftOrderForm.gift_card_session_id"
      />
      <input
        type="hidden"
        name="draft_order_form[gift_code_serial_id]"
        :value="draftOrderForm.gift_code_serial_id"
      />
      <input
        type="hidden"
        name="draft_order_form[draft_order_updated_at]"
        :value="draftOrderForm.draft_order_updated_at"
      />
      <input
        type="hidden"
        name="draft_order_form[gift_card_session_updated_at]"
        :value="draftOrderForm.gift_card_session_updated_at"
      />
      <input
        type="hidden"
        name="draft_order_form[gift_code_serial_updated_at]"
        :value="draftOrderForm.gift_code_serial_updated_at"
      />
      <input
        type="hidden"
        name="draft_order_form[has_alcohol]"
        :value="draftOrderForm.has_alcohol"
      />
      <input
        v-if="draftOrderForm.has_alcohol"
        type="hidden"
        name="draft_order_form[over_twenty_check]"
        :value="draftOrderForm.over_twenty_check"
      />
      <input
        type="hidden"
        name="draft_order_form[amazon_checkout_session_id]"
        :value="draftOrderForm.amazon_checkout_session_id"
      />
    </div>
  </form>
</template>
<script>
export default {
  props: {
    draftOrderForm: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      csrfToken: ''
    }
  },
  mounted() {
    this.csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content')
    setTimeout(() => {
      document.SBAmazonPayConfirmCall.submit()
    }, 50)
  }
}
</script>
